<template>
  <div
    :class="contactUsSectionClass"
    id="contact-us-section"
    class="contact-us-section container"
  >
    <h3 class="contact-us-section__title">Contact Us to Get a Quote</h3>
    <p class="contact-us-section__text">Tell us a little about your product and needs. We’ll get back to you with a quote and how we can work together.</p>
    <contact-form @is-loading="handleLoading" />
  </div>
</template>

<script>
import ContactForm from './ContactForm'

export default {
  name: 'ContactUsSection',
  components: {
    ContactForm,
  },
  data () {
    return {
      isLoading: false,
    }
  },
  computed: {
    contactUsSectionClass () {
      return { 'contact-us-section--loading': this.isLoading }
    },
  },
  methods: {
    handleLoading (isLoading) {
      this.isLoading = isLoading
    },
  }
}
</script>

<style lang="sass" scoped>
@import '~styles/shared'

.contact-us-section
  color: #525f7f
  padding-top: 62px
  padding-bottom: 64px
  position: relative

  @include tablet
    padding-left: 25px
    padding-right: 25px
    padding-bottom: 78px

  @include desktop
    padding-top: 70px
    padding-bottom: 76px

.contact-us-section--loading
  .contact-us-section__title,
  .contact-us-section__text
    @include tablet
      visibility: hidden

.contact-us-section__title
  font: 600 27px Gilroy
  color: #1E3861
  text-align: center
  padding-bottom: 72px
  position: relative

  &:after
    content: ''
    display: block
    border-bottom: 2px solid #365A93
    width: 90px
    margin-left: -45px
    position: absolute
    left: 50%
    bottom: 36px

  @include tablet
    font-size: 34px
    top: 5px
    padding-bottom: 69px

    &:after
      bottom: 41px

.contact-us-section__text
  margin: 0 auto 37px
  padding: 0 10px
  text-align: center
  max-width: 700px

  @include tablet
    margin-bottom: 56px

  @include desktop
    margin-bottom: 63px

.contact-form
  margin: 0 7px
</style>



// WEBPACK FOOTER //
// src/ContactUsSection.vue